// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3kq61","errorLogs":"styles_errorLogs__QMSMH"};